import React, { useState, useEffect } from "react";
import "./warehouseproductlist.css";

// components imports
import WarehouseProductsTable from "../../../../../../../Components/BoltTable/BoltTable";
// apis imports
import { getProductsByWarehouses } from "../../../../../../../services/AdminServices/Users/users.services";
// library imports
import noImage from "../../../../../../../assets/images/noImage.png";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";

const WarehouseProductList = ({ open, setOpen, setSnack }) => {
  const { t } = useTranslation("admin");
  const [warehouseProducts, setWarehouseProducts] = useState([]);

  const ImageUrl = (row) => {
    const url =
      row?.media.find((media) => media.is_primary === "true")?.file ||
      row?.media[0]?.file;
    return url || noImage;
  };

  const columns = [
    {
      id: 1,
      label: t("users.client"),
      render: (row) => <>{row?.shipper?.username ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("users.productId"),
      render: (row) => <>{row?.code ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("users.image"),
      render: (row) => (
        <>
          <img
            src={ImageUrl(row)}
            onError={(e) => {
              e.target.src = noImage;
            }}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 4,
      label: t("users.name"),
      render: (row) => <>{row?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("users.dimensions"),
      render: (row) => (
        <>
          L:{row.length ?? "0"} W:{row.width ?? "0"} H:{row.height ?? "0"} (
          {row.dimension_unit?.toUpperCase() ?? "N/A"})
        </>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("users.productBrand"),
      render: (row) => <>{row?.brand?.name?.toUpperCase() ?? "-"}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("users.weight"),
      render: (row) => (
        <>
          <div className="warehouses__products_weight__button_wrapper">
            <input
              type="text"
              value={row?.weight || "0"}
              disabled
              className="warehouses__products_editble_input"
            />
            <button
              className={
                row?.weight_unit?.toLowerCase() == "lb"
                  ? `warehouses__products_weight_unitbtn_true`
                  : `warehouses__products_weight_unitbtn`
              }
            >
              lb
            </button>
            <button
              className={
                row?.weight_unit?.toLowerCase() == "kg"
                  ? `warehouses__products_weight_unitbtn_true`
                  : `warehouses__products_weight_unitbtn`
              }
            >
              kg
            </button>
          </div>
        </>
      ),
      width: "200px",
    },
    {
      id: 8,
      label: t("users.quantity"),
      render: (row) => <>{row?.product_warehouse[0]["quantity"] ?? "-"}</>,
      width: "200px",
    },
  ];

  const fetchProductsByWarehouses = async (page, perPage, filter) => {
    const response = await getProductsByWarehouses(
      open?.id,
      page,
      perPage,
      filter
    );
    if (!response.error) {
      setWarehouseProducts(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="prdtable__hist_modal">
          <div
            className="prdtable__hist_modalheading history__product_heading  history__main_heading"
            style={{
              border: "none",
            }}
          >
            {t("users.warehouseProducts")}
          </div>
          <div className="prdtable__hist_modalheading history__product_heading history__sub_heading">
            {open?.name ?? ""} ({open?.code ?? ""})
          </div>
          <div className="prdtable__hist_modalcontent history__product_content">
            <WarehouseProductsTable
              tableId="warehouseProductsTableForAdmin"
              message={t("users.noWarehouseProductsAvailableTo")}
              searchPlaceHolder={t("users.searchProducts")}
              columns={columns}
              data={warehouseProducts}
              getAllData={fetchProductsByWarehouses}
              disableAutoResizing={true}
              maxHeight="100%"
            />
          </div>
          <div className=" history__product_footer">
            <div className="history__product_footer_btn" onClick={handleClose}>
              x
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WarehouseProductList;
